import get from 'lodash/get'

export const isImportSiteData = (state) => get(state, ['vegetation', 'site', 'importing'])
export const getImportSiteDataResults = (state) => get(state, ['vegetation', 'site', 'importResults'])



// WEBPACK FOOTER //
// ./src/modules/vegetation/selectors/site.js